/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Socialindicators1Inputs */

const de__field_socialindicators1 = /** @type {(inputs: _Field_Socialindicators1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sozialindikator`)
};

/**

* @param {_Field_Socialindicators1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_socialindicators1 = /** @type {((inputs?: _Field_Socialindicators1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Socialindicators1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_socialindicators1(inputs)
});
export { _field_socialindicators1 as "_field_socialIndicators" }